import { ref } from 'vue';


/** 是否展示分享面板 */
const isShowShare = ref(false);

/** 控制分享面板的展示与隐藏 */
export function useShowShare() {
  /** 展示分享面板 */
  function showShare() {
    isShowShare.value = true;
  }
  /** 隐藏分享面板 */
  function hideShare() {
    isShowShare.value = false;
  }

  return {
    isShowShare,
    showShare,
    hideShare,
  };
}
